import 'style/down.less';

const dWin = document.getElementById( "d_win" );
const dMac = document.getElementById( "d_mac" );
const baseUrl = 'https://assets.geilicdn.com/im/desktop/download';

// 调整为 spider 上报方式
window.spiderReport = {
  paq(actionName) {
    if (window.spider) {
      window.spider.trackAction({ 
        actionName
      });
    }
  }
}

window.spider && spider.trackPageview();

dWin.addEventListener( "click", function() {
  spiderReport.paq( "桌面版im下载页-windows下载点击" );
} );

dMac.addEventListener( "click", function() {
  spiderReport.paq( "桌面版im下载页-mac下载点击" );
} );

window.getversion = function( data ) {
  dWin.setAttribute( "href", `${baseUrl}/wd-chat-${data.version.win}-win.exe?t=v${data.version.win}` );
  dMac.setAttribute( "href", `${baseUrl}/wd-chat-${data.version.mac}-mac.dmg?t=v${data.version.mac}` );

  //判断 url 是否有自动下，
  if(window.location.search.indexOf('download')>=0){
 
    if(window.location.search.indexOf('darwin')>=0){
      dMac.click();
    }else{
      dWin.click();
    }
  }

}

function getDownloadUrl() {
  const script = document.createElement( "script" );
  script.setAttribute( "src", `https://s.geilicdn.com/entry/version.json?t=v1.0.380`);
  document.body.appendChild( script );
}

getDownloadUrl();



/** WEBPACK FOOTER **
 ** ./src/down.js
 **/